import React, { Component } from 'react';
import { translate } from 'react-i18next';

import { actionsBarFactory } from 'common/entity/ActionsBar';
import { IntelliSortSummary } from './IntelliSortSummary';

const ActionsBar = actionsBarFactory({});
class IntelliSortActionsBar extends Component {
    render() {
        const { clientId, selectedDate, homebases } = this.props;
        return (
            <div>
                <ActionsBar {...this.props} />
                <IntelliSortSummary
                    clientId={clientId}
                    selectedDate={selectedDate}
                    homebases={homebases}
                />
            </div>
        );
    }
}

export default translate('translations')(IntelliSortActionsBar);
